import axios from 'src/utils/axios'
import { API_BASE_URL } from 'src/constants'

const diseaseService = {
  /**
   * Get disease list for a specific file
   * @param {string} fileId - The ID of the file
   * @returns {Promise<Array>} - Array of diseases
   */
  getDiseases: async (fileId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/omim-disease-lists/${fileId}/`)
      return response.data
    } catch (error) {
      console.error('Error fetching diseases:', error)
      throw error
    }
  },

  /**
   * Update disease list for a specific file
   * @param {string} fileId - The ID of the file (vcf_id or fastq_pair_id)
   * @param {Array<number>} diseaseKeys - List of disease keys
   * @returns {Promise<Object>} - Response from the server
   */
  updateDiseaseList: async (fileId, diseaseKeys) => {
    // Will create a new disease list if it doesn't exist
    try {
      const response = await axios.patch(`${API_BASE_URL}/omim-disease-lists/${fileId}/`, {
        id: fileId,
        disease_keys: diseaseKeys,
      })
      return response.data
    } catch (error) {
      console.error('Error updating diseases:', error)
      throw error
    }
  },

  /**
   * Delete a disease from the list
   * @param {string} fileId - The ID of the file
   * @param {number} diseaseKey - The disease key (OMIM ID) to delete
   * @returns {Promise<Object>} - Response from the server
   */
  deleteDisease: async (fileId) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/omim-disease-lists/${fileId}/`)
      return response.data
    } catch (error) {
      console.error('Error deleting disease:', error)
      throw error
    }
  },
}

export default diseaseService
